export default __webpack_public_path__ + "/dist/images/campaign-icon.svg";